export default __webpack_public_path__ + "static/media/ttzlb_bg.93c4f215.jpeg";